import { fetchTokenList, fetchTokenLists } from '@1delta/data-sdk'

export function averageDataLastN<T extends { data: number }>(
  arr: readonly T[],
  n = 7,
): number {
  const last = arr.slice(-n)
  if (last.length === 0) return 0
  return last.reduce((sum, x) => sum + x.data, 0) / last.length
}

export const safeFetch = async <T>(
  label: string,
  fn: () => Promise<T>,
): Promise<T | undefined> => {
  try {
    return await fn()
  } catch (e) {
    console.error(`Error fetching ${label}:`, e)
    return undefined
  }
}

export async function getListsMulti(chainIds: string[]) {
  const lists = await fetchTokenLists(chainIds)
  let res: any = {}
  for (const chainId of chainIds) {
    res[chainId] = { list: lists[chainId] }
  }
  return res
}

// Re-export for backwards compatibility
export { fetchTokenList }
